import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button, Dialog, DialogContent, DialogActions,
} from '@material-ui/core';

const S = {
  Dialog: styled(Dialog)`
    .MuiPaper-root {
      width: 280px;
      padding: 8px;
    }
  `,
  DialogContent: styled(DialogContent)`
    padding: 16px;
    color: rgba(0, 0, 0, 0.54);
    font-size: 16px;
    line-height: 1.5;
  `,
  DialogActions: styled(DialogActions)`
    padding: 0;
  `,
  Button: styled(Button)`
    min-width: 0;
    padding: 10px 8px 9px 8px;
    color: #0c8d6d;
    line-height: normal;
  `,
};

const WrongAnswerDialog = ({ open, onClose }) => (
  <S.Dialog open={open} onClose={onClose}>
    <S.DialogContent>
      정보가 올바르지 않습니다.
    </S.DialogContent>
    <S.DialogActions>
      <S.Button type="button" onClick={onClose}>
        닫기
      </S.Button>
    </S.DialogActions>
  </S.Dialog>
);

WrongAnswerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WrongAnswerDialog;
